import { render, staticRenderFns } from "./ManualRuneImg.vue?vue&type=template&id=4897f650&"
import script from "./ManualRuneImg.vue?vue&type=script&lang=js&"
export * from "./ManualRuneImg.vue?vue&type=script&lang=js&"
import style0 from "./ManualRuneImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports